"use client";

import { Flex, Spin, Typography } from "antd";
import { useTranslations } from "@/i18n";

/**
 * Loading state. fullScreen: centred over the whole content area
 * (auth/middleware loading); otherwise a section-sized block for in-page use.
 */
const LoadingScreen = ({
	label,
	fullScreen = true,
}: {
	label?: string;
	fullScreen?: boolean;
}) => {
	const t = useTranslations("common");
	return (
		<Flex
			vertical
			align="center"
			justify="center"
			gap={16}
			className={fullScreen ? "min-h-screen w-full" : "w-full py-24"}
		>
			<Spin size="large" />
			<Typography.Text type="secondary">
				{label ?? t("loading")}
			</Typography.Text>
		</Flex>
	);
};

export default LoadingScreen;
